<script>
	export let data;

	import Login from '@components/Login/index.svelte';
	import NotificationMessage from '@components/NotificationMessage/index.svelte';
	import { apiErrorHandler } from '$lib/utils/apiErrorHandler';
	import { TOKEN } from '$lib/stores/stores';
	import { page } from '$app/stores';
	import {
		TERM,
		CLASSROOMS,
		STUDENTS,
		TERM_DETAILS,
		ADD_STUDENT,
		USER_DETAILS,
		UNIVERSAL_SUCCESS_MESSAGE,
		TOAST_N,
		CURRENT_URL,
		SEARCH_MODE,
		LOGIN_TYPE
	} from '$lib/stores/stores';
	import { GET_STUDENTS } from '$lib/dataproviders/getStudents';
	import { toTitleCase, info, arrayIsNotEqual, checkUserAgentasMobile } from '$lib/utils/helpers';
	import { onMount } from 'svelte';
	import { toastNotify } from '@components/toast';
	import { GET_TERM } from '$lib/dataproviders/getTerms';
	import { PARENT_INFO } from '$lib/stores/parent';
	// import { initLogRocket, setupErrorTracking } from '$lib/utils/logrocket';
	// import * as Sentry from '@sentry/sveltekit';
	import Error from './+error.svelte';
	import { InlineNotification, NotificationActionButton, Link } from 'carbon-components-svelte';
	import { goto } from '$app/navigation';
	import { shouldShowBanner, markBannerAsViewed } from '$lib/utils/bannerUtils';
	// title desc array
	let titleDesc = { title: '', desc: '' };
	let showBanner = false;

	onMount(async () => {
		// initialize logrocket
		if (import.meta.env.VITE_LOGROCKET_ID) {
			// await initLogRocket(import.meta.env.VITE_LOGROCKET_ID, $USER_DETAILS);
			// setup error tracking
			// await setupErrorTracking();
			/* logRocket.getSessionURL((sessionURL) => {
				Sentry.configureScope((scope) => {
					scope.setExtra('sessionURL', sessionURL);
				});
			}); */
		}

		if (!$USER_DETAILS) {
			if ($page.url.pathname.includes('parent')) {
				LOGIN_TYPE.set('parent');
			} else {
				LOGIN_TYPE.set('staff');
			}
			// if (data.showError) {
			// 	UNIVERSAL_ERROR_MESSAGE.set('Login Required!');
			// }
		}

		// Check if banner should be shown
		showBanner = shouldShowBanner(data?.user_type?.toLowerCase() === 'parent');
	});

	const handleBannerLearnMore = () => {
		markBannerAsViewed();
		showBanner = false;
		goto('/finance/split-fees');
	};

	const handleBannerClose = () => {
		markBannerAsViewed();
		showBanner = false;
	};

	let tempTerm = $TERM;
	let tempClassrooms = $CLASSROOMS || [];

	const parent = data?.user_type?.toLowerCase() === 'parent';

	const getStudentsAfterAdd = async () => {
		await getStudents($TERM, $CLASSROOMS);
		ADD_STUDENT.set(false);
	};

	const getParentStudents = async () => {
		$PARENT_INFO?.students && $PARENT_INFO?.students.length > 0
			? await STUDENTS.set($USER_DETAILS?.students)
			: await STUDENTS.set([]);
	};

	let msg = '';
	const getStudents = async (term, classrooms) => {
		if (!term || classrooms.length === 0 || data.isLoggedIn === false) {
			return;
		}
		if ($page.url.pathname.includes('/reports/verification')) {
			return;
		}
		await STUDENTS.set([]);
		const callback = async (res, message) => {
			if (res) {
				const unique = res.filter(
					(value, index, self) => index === self.findIndex((t) => t.studentid === value.studentid)
				);
				await STUDENTS.set(unique);
				// clear search mode
				SEARCH_MODE.set(false);
				// prevents multiple messages
				// only displays on term or classroom change
				// only displays on students page
				if (
					$page.url.pathname.includes('/students') &&
					(msg !== message || tempTerm !== $TERM || tempClassrooms !== $CLASSROOMS)
				) {
					toastNotify(toTitleCase(message), 'success');
					msg = message;
				}
			}
		};
		const onError = async (error) => {
			await STUDENTS.set([]);
		};
		GET_STUDENTS(term, classrooms, $USER_DETAILS?.school[0]?.schoolid, callback, onError);
	};

	const getTerm = async (term_id) => {
		if (!term_id || data.isLoggedIn === false) {
			return;
		}
		const callback = async (res, message) => {
			if (res) {
				await TERM_DETAILS.set(res[0]);
			}
		};
		const onError = (error) => {
			apiErrorHandler(error);
		};
		GET_TERM(term_id, callback, onError);
	};

	const supportUsers = import.meta.env.VITE_SUPPORT_USERS.split(',');

	// store current url for re-login purposes
	$: {
		if ($page.url.pathname) {
			CURRENT_URL.set($page.url.pathname);
		}
		// 	showBanner = shouldShowBanner(data?.user_type?.toLowerCase() === 'parent');
	}

	$: if (tempTerm !== $TERM && parent === false) {
		getStudents($TERM, $CLASSROOMS);
		getTerm($TERM);
		tempTerm = $TERM;
	}
	$: if (arrayIsNotEqual(tempClassrooms, $CLASSROOMS) && parent === false) {
		getStudents($TERM, $CLASSROOMS);
		tempClassrooms = $CLASSROOMS;
	}
	$: $USER_DETAILS && parent === false && $ADD_STUDENT && getStudentsAfterAdd($ADD_STUDENT);

	$: $USER_DETAILS && parent === true && getParentStudents();

	$: {
		if ($UNIVERSAL_SUCCESS_MESSAGE !== '') {
			toastNotify($UNIVERSAL_SUCCESS_MESSAGE, 'success');
			UNIVERSAL_SUCCESS_MESSAGE.set('');
		}
	}
</script>

{#if $TOAST_N}
	<NotificationMessage
		showNotifier={true}
		kind={$TOAST_N.kind}
		title={$TOAST_N.title}
		message={$TOAST_N.message}
	/>
{/if}

{#if $page.error}
	<Error />
{:else if data.isLoggedIn}
	{#if $page.url.pathname.includes('/reports/verification') || (checkUserAgentasMobile() && !parent) || $page.url.pathname.includes('/visualize-report') || $page.url.pathname.includes('/report-comments')}
		<slot />
	{:else}
		<!-- {#if showBanner} -->
		<div class="notification-container">
			{#if ($USER_DETAILS?.school && Array.isArray($USER_DETAILS?.school) && $USER_DETAILS.school[0].grpschoolid === '01') || supportUsers.includes($USER_DETAILS.username)}
				<InlineNotification kind="info" title="" on:close={handleBannerClose}>
					<p slot="subtitle" style="color:#fff;" class="bx--inline-notification__subtitle">
						View Individual Fee Payments from Daily Bulk Settlement in Fee Settlement under Finance
						Module
					</p>
				</InlineNotification>
				<InlineNotification
					kind="info"
					subtitle="Training materials for the new Fee Collection System. Video - Schoolmo Fee Collection System. User Guide Manual - Schoolmo User Guide Manual."
					on:close={handleBannerClose}
				>
					<p slot="subtitle" style="color:#fff;" class="bx--inline-notification__subtitle">
						Training materials for the new Fee Collection System. Video -
						<Link
							inline
							target="_blank"
							href="https://drive.google.com/file/d/1sWnfi4B-5TGhsZeOalXld1GPn0dsYewt/view?usp=drive_link"
						>
							Schoolmo Fee Collection System
						</Link>.
						<br />
						User Guide Manual -
						<Link
							inline
							target="_blank"
							href="https://drive.google.com/file/d/1dEB721s-8OwxLOjzZ2YwnWezsSr6MUNA/view?usp=drive_link"
						>
							Schoolmo User Guide Manual
						</Link>.
					</p>
				</InlineNotification>
				<InlineNotification kind="info" title="" on:close={handleBannerClose}>
					<p
						slot="subtitle"
						style="color:#fff;font-size:1.15rem;"
						class="bx--inline-notification__subtitle"
					>
						<strong>Need Help? We've Got You Covered!</strong>
						<br /><br />

						Introducing the Schoolmo Help Desk.<br /><br />

						You can now create, track, and resolve issues directly within Schoolmo. Whether it's a
						payment concern, student data issue, account access problem, or any other support
						request, our team is just a ticket away.<br /><br />

						📌 Submit a ticket.<br />
						📌 Track its progress.<br />
						📌 Get updates until it's resolved.<br /><br />

						Click - <Link
							inline
							target="_blank"
							style="font-size:1.15rem;"
							href={`https://helpdesk.schoolmo.app/sso?token=${$TOKEN.token.replaceAll('"', '')}`}
						>
							Help Desk
						</Link> anytime to get started.<br />
					</p>
				</InlineNotification>
				<!-- <InlineNotification
					kind="info"
					title="New updates:"
					subtitle="Split fees feature is now available."
					on:close={handleBannerClose}
				>
					<svelte:fragment slot="actions">
						<NotificationActionButton on:click={handleBannerLearnMore}>
							Go to Split
						</NotificationActionButton>
					</svelte:fragment>
				</InlineNotification>
				<InlineNotification kind="info" title="" on:close={handleBannerClose}>
					<p slot="subtitle" style="color:#fff;" class="bx--inline-notification__subtitle">
						<strong>IMPORTANT NOTIFICATIONS PLEASE READ</strong>
						- Each school should ensure that all students have a unique account for school fee collection<br
						/>
						and should be given to PARENTS.<br /> - The account nos. are Wema Accounts but is linked
						to your Account 1 Income account.<br /> - All income into have to go through these
						individual unique accounts including creche.<br /> - Please ensure that you add the
						charges (N300 for KHMS and N350 for FA) as part of the school fee amount given to
						PARENTS.<br />
					</p>
				</InlineNotification>
				 -->
			{/if}

			{#if ($USER_DETAILS?.notifications && !parent && $USER_DETAILS?.notifications?.unread_count > 0)}
				<InlineNotification kind="info" title="" on:close={handleBannerClose}>
					<p
						slot="subtitle"
						style="color:#fff;font-size:1rem;"
						class="bx--inline-notification__subtitle"
					>

						You have {$USER_DETAILS?.notifications?.unread_count || 0} message(s) on Helpdesk<br /><br />

						Click - <Link
							inline
							target="_blank"
							style="font-size:1rem;"
							href={$USER_DETAILS.notifications.deeplink}
						>
							Help Desk
						</Link> to view.<br />
					</p>
				</InlineNotification>
			{/if}
		</div>
		<!-- {/if} -->
		<!-- handles by desktop layout -->
		<slot />
	{/if}
{:else if $page.url.pathname.includes('/parents') && !data.isLoggedIn}
	<Login returnUrl={data.route} currentUrl={data.current_url} userType="parent" />
{:else}
	<Login returnUrl={data.route} currentUrl={data.current_url} userType="staff" />
{/if}

<style>
	.notification-container {
		display: flex;
		background: none;
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 9999;
		/*  */
		top: 2px;
		gap: 0px;
		flex-direction: column;
	}

	:global(.notification-container .bx--inline-notification__title) {
		color: #fff;
	}
	:global(.notification-container .bx--inline-notification--info) {
		margin: 4px;
	}
</style>
